// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3UxE3","icon":"SortAdornment_icon__3vR6J","up":"SortAdornment_up__3KB9f","down":"SortAdornment_down__30Qi4","active":"SortAdornment_active__8Wx9S"};